import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import Spinner from "components/Spinner";
import GoBackButton from "components/project/GoBackButton";
import AdminVideoAnalysisPanel from "components/admin/fileViewer/AdminVideoAnalysisPanel";
import FileViewerErrorBoundary from "components/admin/fileViewer/FileViewerErrorBoundary";
import { getAdminFileDetail } from "lib/api/adminFiles";

export default function AdminVideoFilePage() {
  const { fileId } = useParams();
  const { t, i18n } = useTranslation();
  const [file, setFile] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    let cancelled = false;

    const fetchFile = async () => {
      setIsLoading(true);
      setError(null);
      try {
        const result = await getAdminFileDetail(fileId, {
          locale: i18n.resolvedLanguage || i18n.language || "ko-KR",
        });
        if (cancelled) return;

        if (!result.success) {
          setError(result.message || t("adminFiles.viewerError"));
          return;
        }

        setFile(result.data);
      } catch (err) {
        if (!cancelled) {
          setError(t("adminFiles.viewerError"));
          console.error("Error fetching file:", err);
        }
      } finally {
        if (!cancelled) setIsLoading(false);
      }
    };

    if (fileId) {
      fetchFile();
    }

    return () => {
      cancelled = true;
    };
  }, [fileId, i18n.language, i18n.resolvedLanguage, t]);

  return (
    <FileViewerErrorBoundary>
      <section className="content admin adminVideoFilePage">
        <div className="helpTitleRow">
          <GoBackButton />
          <h2>{t("adminFiles.detailTitle")}</h2>
        </div>

        {isLoading && <Spinner />}

        {error && (
          <div className="card errorMessage">
            <p>{error}</p>
          </div>
        )}

        {file && !isLoading && (
          <AdminVideoAnalysisPanel
            file={file}
            fileId={fileId}
            t={t}
          />
        )}
      </section>
    </FileViewerErrorBoundary>
  );
}
